import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';

const Form = (props) => {
    const { handleOnBlur, loading, inputs, translate } = props;

    const validate = (field) => {
        if (field.required) {
            return (value) => {
                if (!value) {
                    return translate('forms.required');
                }
            };
        }
    };

    return (
        <div>
            { utils.map(inputs, function (input) {
                const label = `resources.orders.filters.${ input.label }.label`;
                const placeholder = `resources.orders.filters.${ input.label }.placeholder`;

                return (
                    <Field
                        component={ input.component }
                        disabled={ loading }
                        key={ input.label }
                        label={ translate(label) }
                        name={ input.name }
                        onBlur={ handleOnBlur }
                        placeholder={ translate(placeholder) }
                        style={ {
                            width: '100%',
                        } }
                        validate={ validate(input) }
                    />
                );
            }) }
        </div>
    );
};

Form.defaultProps = {
    inputs: [],
};

Form.propTypes = {
    handleOnBlur: PropTypes.func,
    inputs: PropTypes.array,
    loading: PropTypes.bool,
    translate: PropTypes.func,
};

export default translate(Form);



// WEBPACK FOOTER //
// ./src/pages/products/productAvailibity/Form.js